import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";

import BaseEntity        from "@/core/misc/BaseEntity";
import Core              from "@/core/Core";
import Qty               from "@/core/types/Qty";
import Sum               from "@/core/types/Sum";
import VatRate           from "@/core/types/VatRate";
import CurrencyRate      from "@/core/types/CurrencyRate";
import PricePrecise      from "@/core/types/PricePrecise";

/**
 * Строка отгрузки Техно — то, что по позиции отгрузки ушло в строку фактуры Техно
 */
@Title_ru_RU_Class('Позиция отгрузки Техно')
class TehnoShipmentPosition extends BaseEntity {
  public shipmentPositionId: number;
  public orderPositionId: number;

  /** Наименование позиции заказа */
  public name: string | null;

  /** Количество в базовых единицах: единиц измерения в Техно нет */
  public qty: Qty;

  public currencyCode: string;
  public sumFull: Sum;
  public vatRate: VatRate | null;
  public vatSum: Sum | null;

  public accountingCurrencyCode: string;
  public accountingCurrencyRate: CurrencyRate | null;
  /** Как в документе поставщика, без дооценки */
  public accountingSumFull: Sum | null;
  /** Доля дооценки документа, приходящаяся на строку */
  public accountingServiceSumFull: Sum;
  public accountingVatSum: Sum | null;
  /** Полная цена за базовую единицу с долей дооценки — то, что записано в фактуру Техно */
  public accountingPriceFull: PricePrecise | null;

  static fromServer(data: any, result = new TehnoShipmentPosition()): TehnoShipmentPosition {
    super.fromServer(data, result);

    result.qty                      = Core.utils.hydrate(data.qty, Qty.fromServer)!;
    result.sumFull                  = Core.utils.hydrate(data.sumFull, Sum.fromServer)!;
    result.vatRate                  = Core.utils.hydrate(data.vatRate, VatRate.fromServer);
    result.vatSum                   = Core.utils.hydrate(data.vatSum, Sum.fromServer);
    result.accountingCurrencyRate   = Core.utils.hydrate(data.accountingCurrencyRate, CurrencyRate.fromServer);
    result.accountingSumFull        = Core.utils.hydrate(data.accountingSumFull, Sum.fromServer);
    result.accountingServiceSumFull = Core.utils.hydrate(data.accountingServiceSumFull, Sum.fromServer)!;
    result.accountingVatSum         = Core.utils.hydrate(data.accountingVatSum, Sum.fromServer);
    result.accountingPriceFull      = Core.utils.hydrate(data.accountingPriceFull, PricePrecise.fromServer);

    return result;
  }

  /** Сумма строки в Техно: строка документа поставщика вместе с долей дооценки */
  get tehnoSumFull(): Sum | null {
    if (this.accountingSumFull === null) {
      return null;
    }
    else {
      return this.accountingSumFull.plus(this.accountingServiceSumFull);
    }
  }
}

export default TehnoShipmentPosition;
